import "./SuccessPopup.scss";
import yetiHeartDance from "../../../../appAssets/jsons/yetiHeartDance.json";
import Lottie from "lottie-react";
import closeIcon from "../../../../appAssets/closeIcon.png";
interface SuccessPopupProps {
  titleText: string;
  btnText: string;
  onPress: () => void;
  onClose: () => void;
}

/**
 * Shown after the doodle is saved — mirrors FunboxSuccessScreen.
 * Same purple gradient + bouncy yeti vibe as the rest of the kid screens.
 */
function SuccessPopup({
  titleText,
  btnText,
  onPress,
  onClose,
}: SuccessPopupProps) {
  return (
    <div className="success-popup__overlay">
      <div className="success-popup__card">
        {/* Row 1 — title + close icon side-by-side */}
        <div className="success-popup__header">
          <h2 className="success-popup__title">{titleText}</h2>
          <button
            type="button"
            className="success-popup__close"
            onClick={onClose}
            aria-label="Close"
          >
            <img src={closeIcon} alt="Close" className="success-popup__close-icon" />
          </button>
        </div>

        {/* Row 2 — Lottie image */}
        <Lottie
          animationData={yetiHeartDance}
          loop={true}
          autoplay={true}
          className="success-popup__icon"
        />

        {/* Row 3 — CTA button */}
        <button type="button" className="success-popup__cta" onClick={onPress}>
          {btnText}
        </button>
      </div>
    </div>
  );
}

export default SuccessPopup;
